import Icons, { IconsProps } from '../../Icons';

export type LockProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/

export function Lock(props: LockProps) {
  return (
    <Icons {...props}>
      <path d="M6.625 21c-.45 0-.833-.158-1.15-.475A1.566 1.566 0 0 1 5 19.375v-8.75c0-.45.158-.833.475-1.15.317-.317.7-.475 1.15-.475H8V7c0-1.117.388-2.063 1.163-2.838C9.938 3.387 10.883 3 12 3c1.117 0 2.063.387 2.838 1.162C15.613 4.937 16 5.883 16 7v2h1.375c.45 0 .833.158 1.15.475.317.317.475.7.475 1.15v8.75c0 .45-.158.833-.475 1.15-.317.317-.7.475-1.15.475H6.625Zm0-1h10.75a.61.61 0 0 0 .45-.175.61.61 0 0 0 .175-.45v-8.75a.61.61 0 0 0-.175-.45.61.61 0 0 0-.45-.175H6.625a.609.609 0 0 0-.45.175.61.61 0 0 0-.175.45v8.75a.61.61 0 0 0 .175.45.609.609 0 0 0 .45.175ZM12 16.5c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 12 13.5c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 10.5 15c0 .417.146.77.438 1.062.291.292.645.438 1.062.438ZM9 9h6V7c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 4c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 7v2Z" />
    </Icons>
  );
}
